module.exports = __webpack_public_path__ + "img/back.a413466c.svg";